import React from 'react';

import { DataTableRow } from 'cpool-components/general/DataTable';

import type { Credit } from '../../../types';
import { cn } from '~/utils/cnTailwind';

type Props = {
    children: React.ReactNode;
    credit: Credit;
    tableContentRow?: boolean;
    onClick?: () => void;
};

export const TableRow: React.FC<Props> = ({ children, credit, onClick, tableContentRow = false }) => {
    if (credit.id === '') {
        return null;
    }

    return (
        <DataTableRow
            payload={credit}
            className={cn(
                'relative text-sm text-midnight whitespace-nowrap [&>td]:px-3',
                tableContentRow ? '[&>td]:py-2.5 hover:bg-grey-light' : 'bg-surface-light',
                onClick && 'cursor-pointer',
            )}
            onClick={onClick}
        >
            {children}
        </DataTableRow>
    );
};
